var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L0.999999 15",
    stroke: "#829AB5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6745 2.23864L16.7657 7.42386C17.0781 7.74205 17.0781 8.25794 16.7657 8.57614L11.6745 13.7614C11.3621 14.0795 10.8556 14.0795 10.5431 13.7614C10.2307 13.4432 10.2307 12.9273 10.5431 12.6091L14.2686 8.81478L5.8 8.81478C5.35817 8.81478 5 8.44999 5 8C5 7.55001 5.35817 7.18522 5.8 7.18522L14.2686 7.18522L10.5431 3.39091C10.2307 3.07272 10.2307 2.55683 10.5431 2.23864C10.8556 1.92045 11.3621 1.92045 11.6745 2.23864Z",
    fill: "#829AB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatClose);
export default __webpack_public_path__ + "static/media/chat-close.6640ab855ddfef0013debd4cfe4d21e0.svg";
export { ForwardRef as ReactComponent };